// extracted by mini-css-extract-plugin
export default {"tcStatusRow":"ticket-account_tcStatusRow__980FN"};